<template>
  <div class="container">
    <div v-if="loaded">
      <div class="top">
        <div class="top-container">
          <div class="c-top">
            <div class="c-title">我的体重</div>
            <div class="c-unit">单位：{{ data.unit }}</div>
          </div>
          <div class="c-center" v-if="weightData">
            <div class="c-center-item">
              <div class="c-unit-num cur-weight">
                {{ weightData.change.weight }}
              </div>
            </div>
            <div class="c-center-item">
              <div class="c-text">初始体重</div>
              <div class="c-unit-num">{{ weightData.init_weight }}</div>
            </div>
            <div class="c-center-item">
              <div class="c-text">目标体重</div>
              <div class="c-unit-num">{{ weightData.target_weight }}</div>
            </div>
            <div class="c-center-item">
              <div class="c-text">我的最新变化</div>
              <div class="c-unit-num">
                <span v-if="weightData.change.trend_value"
                  >{{ weightData.change.trend == 1 ? '+' : '-'
                  }}{{ weightData.change.trend_value }}</span
                >
                <span v-else>-</span>
                <span
                  class="iconfont icon-xingzhuangjiehebeifen"
                  :class="{ 'rotate-icon': weightData.change.trend == 1 }"
                  v-if="weightData.change.trend_value"
                ></span>
              </div>
            </div>
          </div>
          <div class="nav-content">
            <div class="nav-list">
              <span
                class="nav-item"
                :class="{ 'nav-item-active': curNav == 0 }"
                @click="changeNav(0)"
                >近一月</span
              >
              <span class="nav-item-line"></span>
              <span
                class="nav-item"
                :class="{ 'nav-item-active': curNav == 1 }"
                @click="changeNav(1)"
                >近半年</span
              >
            </div>
          </div>
          <!-- 折线图 -->
          <div class="canvas-container">
            <div
              style="height: 100%"
              v-for="(item1, index1) in navData"
              :key="index1"
              v-show="curNav == index1"
            >
              <line-canvas
                :data="item1.data"
                v-if="item1.loaded && item1.data"
              ></line-canvas>
              <div class="not-data" v-if="!item1.dataLength && index1 == 0">
                <div class="desc1">暂无月度记录</div>
                <div class="desc2">瘦身，从学会观察自我变化曲线开始</div>
              </div>
              <div class="not-data" v-if="!item1.dataLength && index1 == 1">
                <div class="desc1">暂无半年记录</div>
                <div class="desc2">记得多多记录自己哦</div>
              </div>
            </div>
          </div>
          <div class="canvas-tips">
            <div class="before"></div>
            <div class="tip" v-show="curNav == 0">已自动筛选当日最新数据</div>
            <div class="tip" v-show="curNav == 1">已自动筛选当月平均数据</div>
            <div class="after"></div>
          </div>
        </div>
        <BannerText
          class="banner-container"
          :data="bannerTextList"
        ></BannerText>
      </div>
      <div class="bottom">
        <!-- 体重描述 -->
        <div class="weight-desc">
          <div class="desc-title">体重</div>
          <div class="desc-item">
            是指身体的重量，包括身体脂肪组织的重量和骨骼，肌肉、体液等非脂肪组织的重量。
          </div>
          <div class="desc-item">
            体重过低：一般反映摄入能力不足，可导致营养不良。
            体重过高：一般反映能量摄入相对过多或活动不足，会显著增加<span
              class="pink"
              >Ⅱ型糖尿病、冠心病、癌症</span
            >
            等疾病的风险。
          </div>
        </div>
        <HistoryComponent
          :data="historyList"
          :unit="data.unit"
          :field="data.field"
          :title="data.title"
          :finished="finished"
          :rulerOptions="data.rulerOptions"
        />
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-else
      text-color="#4a3d6b"
      color="#4a3d6b"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import LineCanvas from '../line-canvas/line-canvas.vue'
import HistoryComponent from './history-component.vue'
import BannerText from './banner-text.vue'
export default {
  components: {
    LineCanvas,
    HistoryComponent,
    BannerText
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      curNav: 0,
      page: 1,
      bannerTextList: [],
      historyList: [],
      loaded: false,
      historyLoading: false, //历史记录是否在加载
      finished: false,
      weightData: null,
      navData: [
        {
          title: '近一月',
          index: 0,
          type: 'day',
          loaded: false,
          dataLength: 0,
          data: null
        },
        {
          title: '近一年',
          index: 1,
          type: 'month',
          loaded: false,
          dataLength: 0,
          data: null
        }
      ]
    }
  },
  created() {
    this.getBannerTextData()
    this.getHistory()
  },
  mounted() {
    this.getWeight(this.navData[this.curNav].type, this.curNav)
  },
  methods: {
    //根据id删除记录
    delRecord(id) {
      for (let i = 0; i < this.historyList.length; i++) {
        if (id == this.historyList[i].id) {
          this.historyList.splice(i, 1)
          break
        }
      }
      this.getWeight(this.navData[this.curNav].type, this.curNav)
    },
    //编辑记录
    editRecord(id, value) {
      for (let i = 0; i < this.historyList.length; i++) {
        if (id == this.historyList[i].id) {
          this.historyList[i].data_value = (+value).toFixed(1)
          break
        }
      }
      this.getWeight(this.navData[this.curNav].type, this.curNav)
    },
    //添加记录
    updateRecord(value) {
      this.setWeight(value)
    },
    setWeight(value) {
      let params = {
        data_field: this.data.field,
        data_value: value
      }
      this.$http
        .postAppWithAppInfo('member/UserBodyData/addUserBodyData', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('添加成功')
            this.page = 1
            this.finished = false
            this.navData.map((item) => {
              item.loaded = false
            })
            this.getHistory(true)
            this.getWeight(this.navData[this.curNav].type, this.curNav)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    changeNav(index) {
      this.curNav = index
      if (!this.navData[index].loaded) {
        this.getWeight(this.navData[index].type, index)
      }
    },
    getBannerTextData() {
      let params = {
        position_type: '6', //位置类型
        resource_type: '3' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.bannerTextList = res.data
          }
        })
        .catch((err) => {})
    },
    getWeight(type, curNav) {
      let params = {
        time_type: type,
        time_length: 30
      }
      this.$http
        .getApp('member/UserBodyData/getUserBodyDataWeightTrend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.navData[curNav].dataLength = Array.isArray(res.data)
              ? res.data.length
              : res.data.trend.length
            this.navData[curNav].data = Array.isArray(res.data)
              ? this.dealMonthData(res.data)
              : this.dealDayData(res.data.trend)
            this.navData[curNav].loaded = true
            if (res.data.weight_trend_value) {
              res.data.weight_trend_value.change.last_data_value =
                this.toFiexed1(
                  res.data.weight_trend_value.change.last_data_value
                )
              res.data.weight_trend_value.change.trend_value = this.toFiexed1(
                res.data.weight_trend_value.change.trend_value
              )
              res.data.weight_trend_value.change.weight = this.toFiexed1(
                res.data.weight_trend_value.change.weight
              )
              res.data.weight_trend_value.change.init_weight = this.toFiexed1(
                res.data.weight_trend_value.change.init_weight
              )
              this.weightData = res.data.weight_trend_value
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    //保留一位小数
    toFiexed1(num) {
      if (num === null || num === undefined || num === '') {
        return ''
      }
      return (Math.round(num * 10) / 10).toFixed(1)
    },
    getHistory(isCover) {
      if (this.historyLoading || this.finished) {
        return
      }
      this.historyLoading = true
      let lastId = this.historyList.length
        ? this.historyList[this.historyList.length - 1].id
        : 0
      lastId = isCover ? 0 : lastId
      let params = {
        last_id: lastId,
        page_num: 30,
        data_field: this.data.field
      }
      this.$http
        .getApp('member/UserBodyData/getUserHistoryPhysicalIndicators', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (isCover) {
              this.historyList = this.dealHistoryData(res.data)
            } else {
              this.historyList = this.historyList.concat(
                this.dealHistoryData(res.data)
              )
            }
            if (!res.data || !res.data.length) {
              this.finished = true
            }
            this.page++
          }
        })
        .catch(() => {})
        .finally(() => {
          this.historyLoading = false
        })
    },
    dealHistoryData(data) {
      data.map((item) => {
        item.showPopover = false
        item.data_value = this.toFiexed1(item.data_value)
      })
      return data
    },
    dealDayData(arr) {
      let xList = []
      let yList = []
      arr.map((item) => {
        xList.push(this.formatDay(item.day))
        yList.push(this.toFiexed1(item.weight))
      })
      if (arr.length < 7) {
        let len = 7 - arr.length
        for (let i = 0; i < len; i++) {
          xList.push('')
          yList.push(null)
        }
      }
      let res = {
        xList,
        yList
      }
      return res
    },
    dealMonthData(arr) {
      let xList = []
      let yList = []
      arr.map((item) => {
        xList.push(this.formatMonth(item.month))
        yList.push(item.weight)
      })
      if (arr.length < 7) {
        let len = 7 - arr.length
        for (let i = 0; i < len; i++) {
          xList.push('')
          yList.push(null)
        }
      }
      let res = {
        xList,
        yList
      }
      return res
    },
    //处理天数显示方式
    formatDay(str) {
      let res
      str = str.replace(/-/g, '/')
      let difference = new Date().getTime() - new Date(str).getTime()
      let isToday = difference >= 0 && difference <= 1000 * 60 * 60 * 24
      if (isToday) {
        res = '今日'
      } else {
        let arr = str.split('/')
        res = arr[1] + '/' + arr[2]
      }
      return res
    },
    //处理月份显示方式
    formatMonth(str) {
      let arr = str.split('-')
      let res = arr[1] + '月'
      return res
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  min-height: 100%;
  background-color: #f9f9f9;
  box-sizing: border-box;
  padding-bottom: 50px;
}

.c-center {
  display: flex;
  //padding: 0px 14px;
  box-sizing: border-box;
  text-align: center;

  .c-center-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }

  .c-line {
    border-right: 1px solid #efefef;
  }

  .c-text {
    white-space: nowrap;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 17px;
    margin-bottom: 9px;
  }

  .c-unit-num {
    white-space: nowrap;
    height: 32px;
    font-size: 32px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: #fff;
    line-height: 28px;

    .iconfont {
      font-size: 10px;
    }
  }

  .cur-weight {
    height: 66px;
    font-size: 66px;
    font-family: DINCondensed-Bold;
    font-weight: bold;
    color: #ffffff;
    line-height: 54px;
  }

  .c-change {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #6236ff;
    line-height: 17px;
  }

  .icon-item {
    margin-bottom: 10px;
    color: #000;
    font-size: 22px;
  }

  .gray-content {
    margin: 0 auto;
    width: 296px;
    background: #f7f7f7;
    border-radius: 8px;
    display: flex;
    padding: 10px 0px;
    align-items: center;
    margin-bottom: 12px;

    .c-center-item {
      flex: 1;
    }

    .line {
      width: 2px;
      height: 39px;
      background-color: #ebebeb;
    }
  }
}

.nav-content {
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;

  .nav-list {
    display: flex;
    align-items: center;
  }

  .nav-item {
    padding: 2px 10px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    line-height: 17px;
  }

  .nav-item-line {
    width: 1px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .nav-item-active {
    font-weight: 500;
    color: #fff;
  }
}

.top {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  background-color: #4a3d6b;
}

.top-container {
  padding: 0px 20px 20px;
  box-sizing: border-box;
}

.banner-container {
  margin-bottom: 20px;
}

.c-top {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  box-sizing: border-box;

  .c-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
  }

  .c-unit {
    flex: 1;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 17px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-btn {
    height: 25px;
    line-height: 25px;
    padding: 0px 12px;
    background: #ffffff;
    border-radius: 10px;
    border: 2px solid #6236ff;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
  }
}

.canvas-container {
  position: relative;
  width: 100%;
  height: 179px;

  .not-data {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .desc1 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 4px;
    }

    .desc2 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      line-height: 17px;
    }
  }
}

.bottom {
  padding: 20px 20px 24px;
  box-sizing: border-box;
  background: #f9f9f9;
}

.weight-desc {
  background: #ffffff;
  border-radius: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 22px;
  padding: 15px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;

  .desc-title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .desc-item {
    margin-bottom: 10px;
  }

  .desc-item:last-child {
    margin-bottom: 0px;
  }

  .pink {
    color: #ff8c9c;
  }
}

.canvas-tips {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;

  .before,
  .after {
    width: 13px;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .tip {
    height: 17px;
    font-size: 12px;
    margin: 0px 8px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 0.9);
    line-height: 17px;
  }
}

.icon-xingzhuangjiehebeifen {
  display: inline-block;
  color: rgba(53, 199, 99, 1);
  margin-left: 4px;
}

.rotate-icon {
  transform: rotate(180deg);
  transform-origin: center;
  color: #ff2b48;
}

.v-loading {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
</style>
